import { cva } from 'class-variance-authority';

export const subHeroSectionVariants = cva(
  'c-sub-hero-section',
  {
    variants: {
      variant: {
        mediaNone: 'c-sub-hero-section--media-none',
        mediaRight: 'c-sub-hero-section--media-right',
        mediaCenter: 'c-sub-hero-section--media-center',
      },
    },
    defaultVariants: {
      variant: 'mediaNone',
    },
  },
);
